const CONTENTO_PRESENTATION_TYPES = {
    DEFAULT: 'Default',
    SHOWCASE: 'Showcase',
    PORTRAIT: 'PortraitPosters',
};

export default CONTENTO_PRESENTATION_TYPES;
